import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.33_@babel+core@7.28.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/magicui/blur-fade.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MagicCard"] */ "/vercel/path0/src/components/magicui/magic-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Meteors"] */ "/vercel/path0/src/components/magicui/meteors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoText"] */ "/vercel/path0/src/components/magicui/video-text.tsx");
